// Generated from the reviewed Free 6.5.1 SVG shapes, not a webfont/runtime library.
// CC BY 4.0: https://fontawesome.com/license/free
export const CONTENT_ICON_SPRITE = "/images/content-icons-7c896f627455.svg";
export const CONTENT_ICON_DEFINITIONS: Record<string, { viewBox: string; width: number }> = {
  "1": {
    "viewBox": "0 0 256 512",
    "width": 0.5
  },
  "2": {
    "viewBox": "0 0 320 512",
    "width": 0.625
  },
  "3": {
    "viewBox": "0 0 320 512",
    "width": 0.625
  },
  "4": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "5": {
    "viewBox": "0 0 320 512",
    "width": 0.625
  },
  "6": {
    "viewBox": "0 0 320 512",
    "width": 0.625
  },
  "arrow-down": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "arrow-right": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "arrows-left-right": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "arrows-up-down": {
    "viewBox": "0 0 320 512",
    "width": 0.625
  },
  "bed": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "bed-pulse": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "bolt": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "box": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "boxes-stacked": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "briefcase": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "building": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "building-columns": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "calendar-check": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "calendar-days": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "check": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "chevron-down": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "circle-question": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "city": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "clock": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "compass-drafting": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "couch": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "crown": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "cube": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "cubes": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "cubes-stacked": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "door-closed": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "door-open": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "droplet": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "envelope": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "file-invoice": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "file-pdf": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "file-signature": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "fire": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "fire-flame-curved": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "gears": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "gem": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "grip-lines-vertical": {
    "viewBox": "0 0 192 512",
    "width": 0.375
  },
  "hammer": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "hand-pointer": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "handshake": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "hotel": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "house-chimney": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "house-chimney-window": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "house-user": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "industry": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "kitchen-set": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "layer-group": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "leaf": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "lightbulb": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "location-dot": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "monument": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "mountain": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "mountain-sun": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "paint-roller": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "paper-plane": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "paperclip": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "pen-ruler": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "phone": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "plug": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  },
  "plus": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "recycle": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "rotate": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "route": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "ruler": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "ruler-combined": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "screwdriver-wrench": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "shield-halved": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "shirt": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "snowflake": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "socks": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "spray-can": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "square": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "stairs": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "star": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "swatchbook": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "table-cells": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "tree": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "tree-city": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "triangle-exclamation": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "truck": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "truck-fast": {
    "viewBox": "0 0 640 512",
    "width": 1.25
  },
  "user-secret": {
    "viewBox": "0 0 448 512",
    "width": 0.875
  },
  "vault": {
    "viewBox": "0 0 576 512",
    "width": 1.125
  },
  "wind": {
    "viewBox": "0 0 512 512",
    "width": 1
  },
  "wine-glass": {
    "viewBox": "0 0 320 512",
    "width": 0.625
  },
  "xmark": {
    "viewBox": "0 0 384 512",
    "width": 0.75
  }
};
export const CONTENT_ICON_ALIASES: Record<string,string> = {
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "arrow-down": "arrow-down",
  "arrow-right": "arrow-right",
  "arrows-left-right": "arrows-left-right",
  "arrows-h": "arrows-left-right",
  "arrows-up-down": "arrows-up-down",
  "arrows-v": "arrows-up-down",
  "bed": "bed",
  "bed-pulse": "bed-pulse",
  "procedures": "bed-pulse",
  "bolt": "bolt",
  "zap": "bolt",
  "box": "box",
  "boxes-stacked": "boxes-stacked",
  "boxes": "boxes-stacked",
  "boxes-alt": "boxes-stacked",
  "briefcase": "briefcase",
  "building": "building",
  "building-columns": "building-columns",
  "bank": "building-columns",
  "institution": "building-columns",
  "museum": "building-columns",
  "university": "building-columns",
  "calendar-check": "calendar-check",
  "calendar-days": "calendar-days",
  "calendar-alt": "calendar-days",
  "check": "check",
  "chevron-down": "chevron-down",
  "circle-question": "circle-question",
  "question-circle": "circle-question",
  "city": "city",
  "clock": "clock",
  "clock-four": "clock",
  "compass-drafting": "compass-drafting",
  "drafting-compass": "compass-drafting",
  "couch": "couch",
  "crown": "crown",
  "cube": "cube",
  "cubes": "cubes",
  "cubes-stacked": "cubes-stacked",
  "door-closed": "door-closed",
  "door-open": "door-open",
  "droplet": "droplet",
  "tint": "droplet",
  "envelope": "envelope",
  "file-invoice": "file-invoice",
  "file-pdf": "file-pdf",
  "file-signature": "file-signature",
  "fire": "fire",
  "fire-flame-curved": "fire-flame-curved",
  "fire-alt": "fire-flame-curved",
  "gears": "gears",
  "cogs": "gears",
  "gem": "gem",
  "grip-lines-vertical": "grip-lines-vertical",
  "hammer": "hammer",
  "hand-pointer": "hand-pointer",
  "handshake": "handshake",
  "hotel": "hotel",
  "house-chimney": "house-chimney",
  "home-lg": "house-chimney",
  "house-chimney-window": "house-chimney-window",
  "house-user": "house-user",
  "home-user": "house-user",
  "industry": "industry",
  "kitchen-set": "kitchen-set",
  "layer-group": "layer-group",
  "leaf": "leaf",
  "lightbulb": "lightbulb",
  "location-dot": "location-dot",
  "map-marker-alt": "location-dot",
  "monument": "monument",
  "mountain": "mountain",
  "mountain-sun": "mountain-sun",
  "paint-roller": "paint-roller",
  "paper-plane": "paper-plane",
  "paperclip": "paperclip",
  "pen-ruler": "pen-ruler",
  "pencil-ruler": "pen-ruler",
  "phone": "phone",
  "plug": "plug",
  "plus": "plus",
  "add": "plus",
  "recycle": "recycle",
  "rotate": "rotate",
  "sync-alt": "rotate",
  "route": "route",
  "ruler": "ruler",
  "ruler-combined": "ruler-combined",
  "screwdriver-wrench": "screwdriver-wrench",
  "tools": "screwdriver-wrench",
  "shield-halved": "shield-halved",
  "shield-alt": "shield-halved",
  "shirt": "shirt",
  "t-shirt": "shirt",
  "tshirt": "shirt",
  "snowflake": "snowflake",
  "socks": "socks",
  "spray-can": "spray-can",
  "square": "square",
  "stairs": "stairs",
  "star": "star",
  "swatchbook": "swatchbook",
  "table-cells": "table-cells",
  "th": "table-cells",
  "tree": "tree",
  "tree-city": "tree-city",
  "triangle-exclamation": "triangle-exclamation",
  "exclamation-triangle": "triangle-exclamation",
  "warning": "triangle-exclamation",
  "truck": "truck",
  "truck-fast": "truck-fast",
  "shipping-fast": "truck-fast",
  "user-secret": "user-secret",
  "vault": "vault",
  "wind": "wind",
  "wine-glass": "wine-glass",
  "xmark": "xmark",
  "close": "xmark",
  "multiply": "xmark",
  "remove": "xmark",
  "times": "xmark",
  "fire-flame-curled": "fire-flame-curved"
};
export const CONTENT_ICON_UNICODES: Record<string,string> = {
  "31": "1",
  "32": "2",
  "33": "3",
  "34": "4",
  "35": "5",
  "36": "6",
  "f063": "arrow-down",
  "f061": "arrow-right",
  "f07e": "arrows-left-right",
  "f07d": "arrows-up-down",
  "f236": "bed",
  "f487": "bed-pulse",
  "f0e7": "bolt",
  "f466": "box",
  "f468": "boxes-stacked",
  "f0b1": "briefcase",
  "f1ad": "building",
  "f19c": "building-columns",
  "f274": "calendar-check",
  "f073": "calendar-days",
  "f00c": "check",
  "f078": "chevron-down",
  "f059": "circle-question",
  "f64f": "city",
  "f017": "clock",
  "f568": "compass-drafting",
  "f4b8": "couch",
  "f521": "crown",
  "f1b2": "cube",
  "f1b3": "cubes",
  "e4e6": "cubes-stacked",
  "f52a": "door-closed",
  "f52b": "door-open",
  "f043": "droplet",
  "f0e0": "envelope",
  "f570": "file-invoice",
  "f1c1": "file-pdf",
  "f573": "file-signature",
  "f06d": "fire",
  "f7e4": "fire-flame-curved",
  "f085": "gears",
  "f3a5": "gem",
  "f7a5": "grip-lines-vertical",
  "f6e3": "hammer",
  "f25a": "hand-pointer",
  "f2b5": "handshake",
  "f594": "hotel",
  "e3af": "house-chimney",
  "e00d": "house-chimney-window",
  "e1b0": "house-user",
  "f275": "industry",
  "e51a": "kitchen-set",
  "f5fd": "layer-group",
  "f06c": "leaf",
  "f0eb": "lightbulb",
  "f3c5": "location-dot",
  "f5a6": "monument",
  "f6fc": "mountain",
  "e52f": "mountain-sun",
  "f5aa": "paint-roller",
  "f1d8": "paper-plane",
  "f0c6": "paperclip",
  "f5ae": "pen-ruler",
  "f095": "phone",
  "f1e6": "plug",
  "2b": "plus",
  "f1b8": "recycle",
  "f2f1": "rotate",
  "f4d7": "route",
  "f545": "ruler",
  "f546": "ruler-combined",
  "f7d9": "screwdriver-wrench",
  "f3ed": "shield-halved",
  "f553": "shirt",
  "f2dc": "snowflake",
  "f696": "socks",
  "f5bd": "spray-can",
  "f0c8": "square",
  "e289": "stairs",
  "f005": "star",
  "f5c3": "swatchbook",
  "f00a": "table-cells",
  "f1bb": "tree",
  "e587": "tree-city",
  "f071": "triangle-exclamation",
  "f0d1": "truck",
  "f48b": "truck-fast",
  "f21b": "user-secret",
  "e2c5": "vault",
  "f72e": "wind",
  "f4e3": "wine-glass",
  "f00d": "xmark"
};
